import { useState } from "react";
import styled from "styled-components";

import Overlay from "../../Overlay";
import Modal from "../../Utils/Modal";
import { useToast } from "../../../contexts/ToastContext";
import useApi from "../../../hooks/useApi";

const Titulo = styled.h2`
    margin: 0 0 10px 0;
    font-size: 17px;
    color: #263b4b;
    text-align: center;
`;

const Subtitulo = styled.p`
    margin: 0;
    font-size: 14px;
    color: #555;
    text-align: center;
    line-height: 1.5;
`;

const Resumo = styled.div`
    margin: 16px 0 0 0;
    padding: 12px;
    background-color: #f5f7fa;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 13px;
    color: #111;

    p {
        margin: 0;
    }

    b {
        color: #263b4b;
    }
`;

const BotoesWrapper = styled.div`
    margin-top: 24px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
`;

const Botao = styled.button`
    padding: 9px 16px;
    background-color: ${(p) => (p.$cancel ? "#e5e7eb" : "#e11d48")};
    color: ${(p) => (p.$cancel ? "#333" : "white")};
    border: none;
    border-radius: 6px;
    font-weight: 600;
    font-size: 13px;
    cursor: pointer;
    transition: background-color 0.15s ease;

    &:hover:not(:disabled) {
        background-color: ${(p) => (p.$cancel ? "#d1d5db" : "#be123c")};
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
`;

const ModalDeleteRac = ({ rac, fecharModal, onDeleted }) => {
    const api = useApi();
    const { notifyError, notifySuccess } = useToast();
    const [removendo, setRemovendo] = useState(false);

    const handleDelete = async () => {
        if (!rac?.id) return;

        setRemovendo(true);

        try {
            const { data } = await api.post("/Painel/API/RAC/Delete/index.php", {
                id: rac.id,
            });

            if (data?.success) {
                notifySuccess(data?.message || "RAC removida com sucesso.");
                if (onDeleted) await onDeleted();
                fecharModal();
                return;
            }

            notifyError(data?.message || "Não foi possível remover a RAC.");
        } catch (err) {
            console.error(err);
            const msg = err?.response?.data?.message || "Erro ao remover RAC.";
            notifyError(msg);
        } finally {
            setRemovendo(false);
        }
    };

    return (
        <Overlay state>
            <Modal size="sm">
                <Titulo>Confirmar exclusão</Titulo>
                <Subtitulo>Tem certeza que deseja remover esta RAC?</Subtitulo>

                {rac && (
                    <Resumo>
                        <p><b>ID:</b> {rac.id}</p>
                        <p><b>FONTE:</b> {rac.fonte ?? "-"}</p>
                        <p><b>CENTRO CUSTO:</b> {rac.centro_custo ?? "-"}</p>
                        <p><b>STATUS:</b> {rac.status ?? "-"}</p>
                    </Resumo>
                )}

                <BotoesWrapper>
                    <Botao type="button" $cancel onClick={fecharModal} disabled={removendo}>
                        CANCELAR
                    </Botao>
                    <Botao type="button" onClick={handleDelete} disabled={removendo}>
                        {removendo ? "REMOVENDO…" : "REMOVER"}
                    </Botao>
                </BotoesWrapper>
            </Modal>
        </Overlay>
    );
};

export default ModalDeleteRac;
